function copyToHidden(source, form) {

    let filterStr = "[name='" + source.name + "']";
    let input = form.querySelector(filterStr);
    if (!input) {
        input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", source.getAttribute('name'));
        form.appendChild(input);
    }
    input.value = source.value;
}

function getCustomiserError(input) {
    const wrapper = input.closest('.product-form__input') || input.parentElement;
    let error = wrapper && wrapper.querySelector('.product-customiser-error');

    if (!wrapper || error) {
        return error;
    }

    error = document.createElement('p');
    error.className = 'product-customiser-error';
    const errorIdBase = (input.id || 'personalisation').replace(/[^a-zA-Z0-9_-]+/g, '-');
    error.id = `${errorIdBase}-error`;
    error.setAttribute('role', 'alert');
    error.hidden = true;
    input.insertAdjacentElement('afterend', error);

    const describedBy = new Set((input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
    describedBy.add(error.id);
    input.setAttribute('aria-describedby', Array.from(describedBy).join(' '));

    return error;
}

function clearCustomiserError(input) {
    const error = getCustomiserError(input);
    input.classList.remove('product-customiser-input--invalid');
    input.removeAttribute('aria-invalid');
    if (error) {
        error.hidden = true;
        error.textContent = '';
    }
}

function showCustomiserError(input) {
    const error = getCustomiserError(input);
    const wrapper = input.closest('.product-form__input') || input;
    const label = Array.from(wrapper.querySelectorAll('label'))
        .find((candidate) => candidate.htmlFor === input.id)
        ?.textContent.trim().toLowerCase();
    const message = input.validity.valueMissing && label
        ? `Please enter ${label} before adding to cart.`
        : input.validationMessage || 'Please complete this field before adding to cart.';

    input.classList.add('product-customiser-input--invalid');
    input.setAttribute('aria-invalid', 'true');
    if (error) {
        error.textContent = message;
        error.hidden = false;
    }

    wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
    input.focus({ preventScroll: true });
}

class DyeforProductFormStandartValidation extends HTMLElement {
    constructor() {
        super();
        this.media = this.closest('.section').querySelector('slider-component-colors');
        this.colors = this.closest('.section').querySelector('media-gallery-colors');
        this.modal = this.closest('body').querySelector('product-modal');
      	this.slider = this.closest('.section').querySelector('slider-component');
    }
    connectedCallback() {
        for (const input of this.querySelectorAll('.product-customiser-input')) {
            getCustomiserError(input);
            if (input.dataset.customiserValidationReady === 'true') {
                continue;
            }

            input.dataset.customiserValidationReady = 'true';
            input.addEventListener('input', () => clearCustomiserError(input));
            input.addEventListener('change', () => clearCustomiserError(input));
        }

        ProductFormValidation.addValidation(() => {
            let parent = this.closest('.product__info-wrapper');
            let form = parent.querySelector('product-form form');
            for (const input of this.querySelectorAll('.product-customiser-input')) {
                if (!input.checkValidity()) {
                    showCustomiserError(input);
                    return false;
                }

                clearCustomiserError(input);
                copyToHidden(input, form);
            }
            return true;
        });

        let variantSelect = this.closest('.product__info-container').querySelector('variant-selects');
        if(variantSelect){
          variantSelect.addEventListener('change', () => this.refreshImage());
        }
        this.refreshImage();
    }

    refreshImage() {
        let product, varaint;
        varaint = this.findSelectedVariant();
        product = JSON.parse(this.closest('section').querySelector('#product-data').getAttribute('data-product'));
        var clrObj = document.querySelector(".colors_comp");
        clrObj.updateColors(varaint, product);

        let variantSelect = this.closest('.product__info-container').querySelector('variant-selects');
        if(variantSelect){
          variantSelect.addEventListener('change', () => imageRefreshSelectCallback(varaint, product));
        }
        setTimeout(() => imageRefreshSelectCallback(varaint, product), 500);
        this.filterMedia(varaint);
        if(!this.media){
           return;
        }
        this.media.resetPages();
    }

    findSelectedVariant() {
        let idEle = this.closest('.product__info-container').querySelector('[id^="product-form-installment"] [name="id"]'); 
        if (!idEle) {
            return;
        }
        let varaintId = idEle.value;
        if (!varaintId) {
            return;
        }
        //let varaints = this.closest('.product__info-container').querySelector('variant-selects').getVariantData();
        let varaints = FindMainProductHelper.findProduct().variants;
        return varaints.find((i) => i.id == varaintId);
    }
    decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }
    isNoCustom(){
       return "1" == $("#cst_nc").val();
    }
    filterMedia(v) {

        var clrObj = $(".colors_comp")[0];
        var clr = clrObj.getSelectedColor();
        $('[thumbnail-color]').hide().removeClass("loading-thumbnail");
        if(typeof no_variant_images != 'undefined' && no_variant_images == true){
           var ethis = this;
           var toSel = null;
          $(Object.values(allPict)).each(function (ixi, viv) {
             if (viv.alt){
               var tmpSelAlt = ethis.decodeHtml(viv.alt.toLowerCase());
                var tmpglr = ethis.modal.querySelector('[data-sel-alt="' + tmpSelAlt + '"]');
                $(tmpglr).show();
                //$(tmpglr).css('display',null);
                var tmpsld = ethis.slider.querySelector('[data-sel-alt="' + tmpSelAlt + '"]');
                //$(tmpsld).show();
                $(tmpsld).css('display',"");
                if(ethis.media){
                  var tmp = ethis.media.querySelector('[data-sel-alt="' + tmpSelAlt + '"]');
                  $(tmp).show();
                }
                if (toSel == null) {
                    toSel = tmp;
                }
             }
          });
          if (toSel) {
                    $(toSel).find("button").click();
                }
          
          return;
        }

        if (cst_previewHandler == null) {
            var selected_variant = "";//this.currentVariant.featured_media.alt;

            //var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';
            var selected_attribute = '[thumbnail-color="' + clr + '"]';

            if (selected_variant == selected_variant) {
                var tmpvarImg = allVarImg[v.id];
                var ethis = this;
                var toSel = null;
                $(tmpvarImg).each(function (ixi, viv) {
                    if (viv.length == 2 && (viv[0] == clr || viv[0] == 'any')) {
                        var tmpglr = ethis.modal.querySelector('[data-sel-alt="' + viv[1] + '"]');
                        $(tmpglr).show();
                        //$(tmpglr).css('display',null);
                        var tmpsld = ethis.slider.querySelector('[data-sel-alt="' + viv[1] + '"]');
                        //$(tmpsld).show();
                        $(tmpsld).css('display',"");
                        if(ethis.media){
                          var tmp = ethis.media.querySelector('[data-sel-alt="' + viv[1] + '"]');
                          $(tmp).show();
                        }
                        if (toSel == null) {
                            toSel = tmp;
                        }
                    }
                });
                if (toSel) {
                    $(toSel).find("button").click();
                }

            }
        } else {
            // from cust
            if (selected_variant == selected_variant) {
                var tmpvarImg = allVarImg[v.id];
                var ethis = this;
                var toSel = null;
                var lstToShow = [];
                var crtselCstInfo = this.getSelectedVariantImages();
                $(tmpvarImg).each(function (ixi, viv) {
                    if (viv.length == 2 && (viv[0] == clr || viv[0] == 'any')) {

                        var tmpglr = ethis.modal.querySelector('[data-sel-alt="' + viv[1] + '"]');
                        $(tmpglr).show();
                      
                      var tmpsld = ethis.slider.querySelector('[data-sel-alt="' + viv[1] + '"]');
                        //$(tmpsld).show();
                        $(tmpsld).css('display',"");
                      
                        if(ethis.media){
                          var tmp = ethis.media.querySelector('[data-sel-alt="' + viv[1] + '"]');
                          //$(tmp).show();
                          if (toSel == null) {
                              toSel = tmp;
                          }
                        }

                        if (crtselCstInfo) {
                            var tcrtCst = crtselCstInfo.cst.Pictures.find(a => a.imgalt && a.imgalt.toLowerCase() == viv[1]);
                            if (tcrtCst) {
                                if (!ethis.isNoCustom() && lstToShow.length > 0 && tcrtCst.UseForCustomizer !== true) {
                                    return;
                                }
                                lstToShow.push(tcrtCst);
                            }
                        }

                    }
                });
                $(lstToShow).each(function (ix1, viv) {
                    var alt1 = viv.imgalt.toLowerCase();
                    if(!ethis.media){
                      return;
                    }
                    var tmp = ethis.media.querySelector('[data-sel-alt="' + alt1 + '"]');
                    if (!tmp) {
                        return;
                    }
                    if(!ethis.isNoCustom())
					{
                      $(tmp).addClass("loading-thumbnail").show();
                    }
                    //if(ix1 ==0)
                    {
                        var gTar = ethis.colors.elements.viewer.querySelector(`[data-media-id="${tmp.dataset.target}"]`);
                        if(!ethis.isNoCustom())
						{
                          $(gTar).addClass("loading-thumbnail");
                          ethis.loadCustomImage(viv);
                        }
                        if (ix1 == 0)
                            $(tmp).find("button").click();

                    }

                });
                //if(toSel){             $(toSel).show();}
            }
        }
    }
}
window.customElements.define('dyefor-product-form-standard-validation', DyeforProductFormStandartValidation);

class DyeforQuantitySelect extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        fetch(quantitySelectDataPath, {
            "method": "GET"
        }).then(response => response.json()).then(data => {
            if (!data.enabled) return;
            let discountData = data.discount_data.find((i) => i.product_type == productType)
            if (!discountData) return;
            this.appliedDiscountData = discountData;
            this.querySelector('button.dropbtn').addEventListener('click', this.quantityDropButtonClicked.bind(this))
            this.querySelector('.quantity-dropdown-wrap').classList.remove('displaynone');
            this.closest('.product__info-container').querySelector('variant-selects').addEventListener('change', () => this.updateUi);
            this.updateUi();

            document.querySelector('body').addEventListener('click', (e) => {
                if (document.querySelector('body').classList.contains('quantity-dropdown-open')) {
                    for (const btn of document.querySelectorAll('dyefor-quantity-select button.dropbtn')) {
                        if (btn.closest('.quantity-dropdown-wrap').classList.contains('open')) {
                            this.closeSelect();
                        }
                    }
                }
            });

            this.querySelector('.quantity-dropdown-input-content .quantity-input').addEventListener('change', this.quantityChanged.bind(this));
            this.addEventListener('recalc-price', this.recalcPrice.bind(this));
            this.closest('.product__info-container').classList.add('has_quantity-dropdown');
        });

    }
    getQuantityDiscount(quantity) {
        let result = { quantity: 0 };
        this.appliedDiscountData.discounts.forEach(function (i) {
            if (i.quantity <= quantity && result.quantity < i.quantity) {
                result = i;
            }
        });
        return result;
    }
    recalcPrice() {

        let productContainer = this.closest('.product__info-container');
        let price__regular = productContainer.querySelector('.price__regular');
        let wasPrice = price__regular.querySelector('was_price');
        if (!wasPrice) {
            let toAddEle = document.createElement('div');
            toAddEle.classList.add('was_price');
            price__regular.appendChild(toAddEle);
        }
        let varaint = this.findSelectedVariant();
        let quantity = this.querySelector('.quantity-dropdown-input-content input.quantity-input').value;
        let price = varaint.price * 0.01;
        let quantityDiscount = this.getQuantityDiscount(quantity);
        let discountedTotal = (price - quantityDiscount.discount) * quantity;
        let fullPriceTotal = price * quantity;
        //let productContainer = this.closest('.product__info-container')
        let price_item = productContainer.querySelector('.price-item.price-item--regular');
        let second_price_line = productContainer.querySelector('.was_price');
        let itempropPriceValue = (price - quantityDiscount.discount);
        let itempropPrice = productContainer.querySelector('meta[itemprop="price"]');
        if(itempropPrice){
            itempropPrice.setAttribute('content', Math.round(itempropPriceValue * 100) /100 );
        }
        let priceMessage = Shopify.formatMoney((price - quantityDiscount.discount) * 100, this.getAttribute('data-money-format'))
            + " <span class='unit_label'>per " + this.appliedDiscountData.singular_name + "</span>";
        price_item.innerHTML = priceMessage;
        // this.parent('span[itemprop="price"]')
        // .attr('content', ((price - quantityDiscount.discount) * quantity).toFixed(2));
        if (quantityDiscount.discount > 0) {
            let wasPriceMessage = "<span class='was_subtotal'>" + Shopify.formatMoney(price * 100 * quantity, this.getAttribute('data-money-format')) + "</span>"
                + " <span class='subtotal_label'>" + Shopify.formatMoney((price - quantityDiscount.discount) * 100 * quantity, this.getAttribute('data-money-format')) + " subtotal</span>";
            second_price_line.innerHTML = wasPriceMessage;
        } else {
            second_price_line.innerHTML = '';
        }
    }
    quantityChanged() {
        this.updateUi();
        this.dispatchEvent(new Event('recalc-price'));
    }

    setQuantity(val) {
        let input = this.querySelector('.quantity-dropdown-input-content .quantity-input');
        input.value = val;
        document.querySelector('body').classList.remove('mobile-no-scroll');
        this.closeSelect();
        input.dispatchEvent(new Event('change'));
    }
    closeSelect() {
        this.querySelector('.quantity-dropdown-wrap').classList.remove('open');
        document.querySelector('body').classList.remove('mobile-no-scroll');
    }
    openSelect() {
        let $dropdown_wrap = this.querySelector('.quantity-dropdown-wrap');
        $dropdown_wrap.classList.add('open');
        document.querySelector('body').classList.add('mobile-no-scroll');
        document.querySelector('body').classList.add('quantity-dropdown-open');
        if (window.innerHeight > $dropdown_wrap.getBoundingClientRect().top + $dropdown_wrap.offsetHeight + $dropdown_wrap.querySelector('.dropdown-content').offsetHeight) {
            $dropdown_wrap.classList.remove('open-top');
        } else {
            $dropdown_wrap.classList.add('open-top');
        }
    }
    quantityDropButtonClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        let btn = e.target;
        let $parent = btn.closest('.quantity-dropdown-wrap');
        if ($parent.classList.contains('open')) {
            this.openSelect();
        } else {
            this.openSelect();
        }
    }
    findSelectedVariant() {
        let idEle = this.closest('.product__info-container').querySelector('[id^="product-form-installment"] [name="id"]'); 
        if (!idEle) {
            return;
        }
        let varaintId = idEle.value;
        if (!varaintId) {
            return;
        }
        //let varaints = this.closest('.product__info-container').querySelector('variant-selects').getVariantData();
        let varaints = FindMainProductHelper.findProduct().variants;
        return varaints.find((i) => i.id == varaintId);
    }
    updateUi() {
        let ul = this.querySelector('.quantity-dropdown-wrap .dropdown-content ul');
        let ul_mobile = this.querySelector('.quantity-dropdown-wrap .dropdown-mobile-content ul');
        ul.innerHTML = "";
        ul_mobile.innerHTML = "";
        let varaint = this.findSelectedVariant();
        if (!varaint) return;
        let price = varaint.price * 0.01;
        let selectedQuantity = this.querySelector('.quantity-dropdown-input-content .quantity-input').value;
        this.appliedDiscountData.discounts.forEach((i) => {
            let itemGeneralName = this.appliedDiscountData.singular_name;
            let styleClass = "";
            if (i.quantity == selectedQuantity) {
                styleClass = 'selected';
            }
            let displayPrice = (price - i.discount) * 100;
            let li = document.createElement('li')
            if (styleClass.length > 0) {
                li.classList.add(styleClass);
            }
            li.addEventListener('click', (e) => { e.preventDefault(); this.setQuantity(i.quantity) });
            li.innerHTML = `${i.quantity} <span class="discount-msg">(<span class="discounted-price">${Shopify.formatMoney(displayPrice, this.getAttribute('data-money-format'))}</span> / ${itemGeneralName})</span>`;
            ul.appendChild(li);

            let li_mobile = document.createElement('li');
            if (styleClass.length > 0) {
                li_mobile.classList.add(styleClass);
            }
            li_mobile.innerHTML = `<a href="javascript: void(0)">${i.quantity} <span class="discount-msg">(<span class="discounted-price">${Shopify.formatMoney(displayPrice, this.getAttribute('data-money-format'))}</span> / ${itemGeneralName})</span></a>`;
            li_mobile.addEventListener('click', (e) => { e.preventDefault(); this.setQuantity(i.quantity) });
            ul_mobile.appendChild(li_mobile);
        });
    }
}
window.customElements.define('dyefor-quantity-select', DyeforQuantitySelect)

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

class DyeforProductAccessories extends HTMLElement {
    dynamicScreenProtectorAccessryChange = false;
    screenProtectorProduct = null;
    screenProtectorCbElement = null;
    screenProtectorDiv = null;

    dynamicLensProtectorAccessryChange = false;
    lensProtectorProduct = null;
    lensProtectorCbElement = null;
    lensProtectorDiv = null;

    addSelectionToBasket = async () => {
        let addToBasketItems = []
        for (const accessory of this.querySelectorAll('.product_accessories_item')) {
            if (accessory.querySelector('input[type=checkbox]').checked) {
                let accessoryselectedVarintId = +accessory.querySelector('[name="varaintId"]').value;
                let properties = {}
                if (accessoryselectedVarintId === 8147532840974 || accessoryselectedVarintId === 31692965380181 || accessoryselectedVarintId === 40333679001685) {
                    //properties = { Accessory: "Yes" };
                } else {
                    let productForm = this.closest('.product__info-wrapper').querySelector('product-form');;
                    let inputProperties = productForm.querySelectorAll('input[name^="properties"]');
                    for (let item of inputProperties) {
                        let propName = item.getAttribute('name');
                        propName = propName.replace('properties[', '').replace(']', '');
                        properties[propName] = item.value;
                    }
                }
                if (accessoryselectedVarintId === 8147532840974 && this.screenProtectorCbElement.overrideItem !== null){
                    accessoryselectedVarintId = this.screenProtectorCbElement.overrideItem.id;
                }
                if (accessoryselectedVarintId === 40333679001685 && this.lensProtectorCbElement.overrideItem !== null){
                    accessoryselectedVarintId = this.lensProtectorCbElement.overrideItem.id;
                }
                addToBasketItems.push({
                    'id': accessoryselectedVarintId,
                    'quantity': 1,
                    properties: properties
                });
            }
        }

        if (addToBasketItems.length > 0) {
            let data = {
                'items': addToBasketItems
            }
            await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    for (const accessory of this.querySelectorAll('.product_accessories_item')) {
                        accessory.querySelector('input[type=checkbox]').checked = false;
                    }
                  
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }

    constructor() {
        super();
    }

    updateScreenProtectorAccessory(){
        if(!this.dynamicScreenProtectorAccessryChange){
            return;
        }
        if(!this.screenProtectorProduct){
            return;
        }

        let select1 =  document.querySelector('variant-selects select[data-option="option1"]');
        if(!select1){
            return;
        }

        let phone = select1.value;
        if(this.screenProtectorProduct.variants.some(p=> p.title === phone)){
            let screenProtector = this.screenProtectorProduct.variants.find(p=> p.title === phone);
            this.screenProtectorCbElement.overrideItem = screenProtector;
            let link = this.screenProtectorDiv.querySelector('.link-wrap a');
            if(link){
                link.title = this.screenProtectorProduct.title;
                link.innerHTML = this.screenProtectorProduct.title;
            }
            if(screenProtector.inventory_quantity < 1){
                this.toggleScreenProtectorVisibility(false);
                //this.screenProtectorCbElement.setAttribute('disabled', 'disabled');
                //this.screenProtectorCbElement.checked = false;
            }else{
                this.toggleScreenProtectorVisibility(true);
                //this.screenProtectorCbElement.removeAttribute('disabled');
                //this.screenProtectorCbElement.checked = false;
            }

        }else{
            this.toggleScreenProtectorVisibility(false);
            //this.screenProtectorCbElement.overrideItem = null;
            //this.screenProtectorCbElement.setAttribute('disabled', 'disabled');
            //this.screenProtectorCbElement.checked = false;
        }
    }


    updateLensProtectorAccessory(){
        if(!this.dynamicLensProtectorAccessryChange){
            return;
        }
        if(!this.lensProtectorProduct){
            return;
        }

        let select1 =  document.querySelector('variant-selects select[data-option="option1"]');
        if(!select1){
            return;
        }

        let phone = select1.value;
        if(this.lensProtectorProduct.variants.some(p=> p.title === phone)){
            let lensProtector = this.lensProtectorProduct.variants.find(p=> p.title === phone);
            this.lensProtectorCbElement.overrideItem = lensProtector;
            let link = this.lensProtectorDiv.querySelector('.link-wrap a');
            if(link){
                link.title = this.lensProtectorProduct.title;
                link.innerHTML = this.lensProtectorProduct.title;
            }
            if(lensProtector.inventory_quantity < 1){
                this.toggleLensProtectorVisibility(false);
            }else{
                this.toggleLensProtectorVisibility(true);
            }

        }else{
            this.toggleLensProtectorVisibility(false);
        }
    }


    toggleScreenProtectorVisibility(show){
        if(show){
            this.screenProtectorCbElement.removeAttribute('disabled');
            this.screenProtectorDiv.classList.remove('hidden');
            this.classList.remove('hidden');
        }else{
            this.screenProtectorCbElement.overrideItem = null;
            this.screenProtectorCbElement.setAttribute('disabled', 'disabled');
            this.screenProtectorCbElement.checked = false;
            this.screenProtectorDiv.classList.add('hidden');

            //if there are no more accessories, hide the accessory section.
            if(document.querySelectorAll('.product_accessories_item').length < 2){
                this.classList.add('hidden');
            }else{
                this.classList.remove('hidden');
            }
        }
    }
    
    toggleLensProtectorVisibility(show){
        if(show){
            this.lensProtectorCbElement.removeAttribute('disabled');
            this.lensProtectorDiv.classList.remove('hidden');
            this.classList.remove('hidden');
        }else{
            this.lensProtectorCbElement.overrideItem = null;
            this.lensProtectorCbElement.setAttribute('disabled', 'disabled');
            this.lensProtectorCbElement.checked = false;
            this.lensProtectorDiv.classList.add('hidden');

            //if there are no more accessories, hide the accessory section.
            if(document.querySelectorAll('.product_accessories_item').length < 2){
                this.classList.add('hidden');
            }else{
                this.classList.remove('hidden');
            }
        }
    }

    connectedCallback() {
        setTimeout(()=>this.waitForProductFormValidation(this.init()));
    }

    waitForProductFormValidation(method) {
        if (window.ProductFormValidation) {
            method();
        } else {
            setTimeout(()=> { this.waitForProductFormValidation(method) }, 50);
        }
    }

    init(){
        ProductFormValidation.addPreAddBasket(this.addSelectionToBasket);
        for (let select of this.querySelectorAll('.accessory_select')) {
            select.addEventListener('change', (e) => {
                var item = e.target.options[e.target.selectedIndex]
                select.closest('.fll').querySelector('.accessory-price').innerHTML = item.getAttribute('data-price');
                select.closest('.product_accessories_item').querySelector('.accessory-image').src = item.getAttribute('data-image');
            })
        }
        this.screenProtectorCbElement = this.querySelector('.product_accessories_item[data-handle="tempered-glass-screen-protector-for-iphone"] input[type="checkbox"]');
        this.screenProtectorDiv = this.querySelector('.product_accessories_item[data-handle="tempered-glass-screen-protector-for-iphone"]');

        this.lensProtectorCbElement = this.querySelector('.product_accessories_item[data-handle="tempered-glass-camera-lens-protector"] input[type="checkbox"]');
        this.lensProtectorDiv = this.querySelector('.product_accessories_item[data-handle="tempered-glass-camera-lens-protector"]');

        if (this.screenProtectorCbElement && (productType == "Phone Case" || productType == "SamsungV2" || productType == "AppleV2" || productType == "Phone Case Breed" || productType == "Samsung Vegan Leather Flip Phone Case")) {
            this.screenProtectorCbElement.overrideItem=null;
            let screenProtectorHandle = '';
            if (productHandle.includes('iphone')) {
                screenProtectorHandle = 'tempered-glass-screen-protector-for-iphone-1'
            }else if(productHandle.includes('samsung')){
                screenProtectorHandle = 'tempered-glass-screen-protector-for-samsung'
            }else if(productHandle.includes('oneplus')){
                screenProtectorHandle = 'tempered-glass-screen-protector-for-oneplus'
            }else if(productHandle.includes('nokia')){
                screenProtectorHandle = 'tempered-glass-screen-protector-for-nokia'
            }else if(productHandle.includes('huawei')){
                screenProtectorHandle = 'tempered-glass-screen-protector-for-huawei'
            }else if(productHandle.includes('google')){
                screenProtectorHandle = 'tempered-glass-screen-protector-for-google-pixel'
            }else if(productHandle.includes('sony')){
                screenProtectorHandle = 'tempered-glass-screen-protector-for-sony'
            }
            this.dynamicScreenProtectorAccessryChange = screenProtectorHandle.length > 0;
            if(this.dynamicScreenProtectorAccessryChange){
                fetch('/products/'+screenProtectorHandle+'.json')
                .then(res => res.json())
                .then((data)=>{
                    this.screenProtectorProduct = data.product;
                    document.addEventListener('variantchanged', (event)=>{
                        let varaint = event.detail;
                        this.updateScreenProtectorAccessory();
                    });

                    this.updateScreenProtectorAccessory();
                });
            }
        }

        if (this.lensProtectorCbElement && (productType == "Phone Case" || productType == "SamsungV2" || productType == "AppleV2" || productType == "Phone Case Breed" || productType == "Samsung Vegan Leather Flip Phone Case")) {
            this.lensProtectorCbElement.overrideItem=null;
            let lensProtectorHandle = '';
            if (productHandle.includes('iphone')) {
                lensProtectorHandle = 'tempered-glass-camera-lens-protector-for-iphone'
            }
            this.dynamicLensProtectorAccessryChange = lensProtectorHandle.length > 0;
            if(this.dynamicLensProtectorAccessryChange){
                fetch('/products/'+lensProtectorHandle+'.json')
                .then(res => res.json())
                .then((data)=>{
                    this.lensProtectorProduct = data.product;
                    document.addEventListener('variantchanged', ()=>{
                        this.updateLensProtectorAccessory();
                    });

                    this.updateLensProtectorAccessory();
                });
            }
        }

        //this should have its own componenet. refactor later
        document.addEventListener('variantchanged', (event)=>{
            this.showVariantSpecificMessage();
        });
        this.showVariantSpecificMessage();

        document.addEventListener('variantchanged', (event)=>{
            this.updateFollowMainAccessories();
        });

        this.updateFollowMainAccessories();
        
    }

    updateFollowMainAccessories(){
        let select1 =  document.querySelector('variant-selects select[data-option="option1"]');
        if(!select1){
            return;
        }
        if (select1.selectedIndex === -1) {
            return null;
        }
        let selectedText = select1.options[select1.selectedIndex].text;
        
        let toFollowSelects = this.querySelectorAll('select.accessory_select[data-follow-main="true"]');
        for(const toFollowSelect of toFollowSelects){
            console.log(toFollowSelect);
            let options = toFollowSelect.querySelectorAll('option');
            for(const option of options){
                if(option.text === selectedText){
                    toFollowSelect.value = option.value;
                    const e = new Event("change");
                    toFollowSelect.dispatchEvent(e);
                    break;
                }
            }
        }
    } 
    showVariantSpecificMessage(){
        let select1 =  document.querySelector('variant-selects select[data-option="option1"]');
        if(!select1){
            return;
        }

        let phone = select1.value;
        let message = "";
        //if(phone.toLowerCase().startsWith("iphone 14") && productHandle.includes('leather')){          
        //    message= "Leather iPhone 14 cases ship 4th October 2022";
        //}
        
        let deliverycountdown = document.querySelector('.deliverycountdown');
        if(deliverycountdown){
            if(message){
                deliverycountdown.classList.add('hidden');
            }else{
                deliverycountdown.classList.remove('hidden');
            }
        }
        
        document.querySelectorAll(".product-late-message").forEach(el=>{
            el.innerHTML = message;
            if(message){
                el.classList.remove('hidden');
            }else{
                el.classList.add('hidden');
            }

        });
    }
}
window.customElements.define('dyefor-product-accessories', DyeforProductAccessories)

class DyeforCustomizer extends HTMLElement {
    constructor() {
        super();
        this.media = this.closest('.section').querySelector('slider-component-colors');
        this.colors = this.closest('.section').querySelector('media-gallery-colors');
        this.modal = this.closest('body').querySelector('product-modal');
      	this.slider = this.closest('.section').querySelector('slider-component');
    }

    connectedCallback() {
        setTimeout(()=>this.init());
    }

    init(){
        try{
            if(typeof(customizationPerformValidationOnAdd) == "function"){
              ProductFormValidation.addValidation(customizationPerformValidationOnAdd);
            }
            ProductFormValidation.addValidation(this.addHiddenFieldsToProductForm.bind(this));
          }catch(e){
            
          }
        let variantSelect = this.closest('.product__info-container').querySelector('variant-selects');
        if(variantSelect){
          variantSelect.addEventListener('change', () => this.refreshImage());
        }
        this.addEventListener('change', () => this.refreshImage());
        //this.colors.addEventListener('change', () => this.refreshImage());
        InitAllVars();
        this.refreshImage();
    }
    decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }
    addHiddenFieldsToProductForm(){
        let parent = this.closest('.product__info-wrapper');
        let form = parent.querySelector('product-form form');
        this.querySelectorAll('input[name^=properties]').forEach((hidden)=>{
            copyToHidden(hidden, form)
        })
        return true;
    }

    normaliseMediaAlt(value) {
        return this.decodeHtml(String(value || '')).replace(/\s+/g, ' ').trim().toLowerCase();
    }

    findMediaByAlt(root, alt) {
        if (!root) return null;
        var wanted = this.normaliseMediaAlt(alt);
        return Array.from(root.querySelectorAll('[data-sel-alt]')).find((element) => {
            return this.normaliseMediaAlt(element.getAttribute('data-sel-alt')) == wanted;
        }) || null;
    }

    resolveMediaTargets(alt) {
        var thumbnail = this.findMediaByAlt(this.media, alt);
        var viewer = this.colors && this.colors.elements
            ? this.colors.elements.viewer
            : this.slider;
        var gallery = null;

        if (thumbnail && thumbnail.dataset.target && viewer) {
            gallery = Array.from(viewer.querySelectorAll('[data-media-id]')).find((element) => {
                return element.dataset.mediaId == thumbnail.dataset.target;
            }) || null;
        }
        if (!gallery) gallery = this.findMediaByAlt(viewer, alt);

        return { thumbnail: thumbnail, gallery: gallery };
    }

    activateMediaTarget(targets) {
        if (targets.thumbnail) {
            var button = targets.thumbnail.querySelector('button');
            if (button) {
                button.click();
                return;
            }
        }
        if (!targets.gallery) return;
        targets.gallery.style.removeProperty('display');
        if (this.colors && typeof this.colors.setActiveMedia == 'function' && targets.gallery.dataset.mediaId) {
            this.colors.setActiveMedia(targets.gallery.dataset.mediaId, false);
            return;
        }
        if (targets.gallery.parentElement) {
            targets.gallery.parentElement.querySelectorAll('[data-media-id].is-active').forEach((element) => {
                element.classList.remove('is-active');
            });
        }
        targets.gallery.classList.add('is-active');
    }

    updateRenderedImage(container, url) {
        if (!container) return false;
        var image = container.matches && container.matches('img') ? container : container.querySelector('img');
        if (!image) return false;
        if (!image.getAttribute('srcorig')) image.setAttribute('srcorig', image.getAttribute('src') || '');
        if (!image.getAttribute('srcsetorig') && image.getAttribute('srcset')) {
            image.setAttribute('srcsetorig', image.getAttribute('srcset'));
        }
        image.removeAttribute('srcset');
        var picture = image.closest('picture');
        if (picture) {
            picture.querySelectorAll('source').forEach((source) => source.removeAttribute('srcset'));
        }
        image.src = url;
        image.setAttribute('data-dyefor-custom-preview', 'true');
        return true;
    }

    preserveApprovedAIPreview() {
        const bridge = window.DyeforAIImageBridge;
        return Boolean(bridge && typeof bridge.preserveApprovedProductPreview === 'function'
            && bridge.preserveApprovedProductPreview());
    }

    refreshImage() {
        let product, varaint;
        varaint = this.findSelectedVariant();
        product = JSON.parse(this.closest('section').querySelector('#product-data').getAttribute('data-product'));
       if(typeof(customizerOnSelectCallback) != 'undefined') 
        {
          if(typeof no_variant_images != 'undefined' && no_variant_images == true){
           var ethis = this;
           var toSel = null;
            var tmpAllPict = [...product.media];
              $(Object.values(tmpAllPict)).each(function (ixi, viv) {
                 if (viv.alt){
                   var tmpSelAlt = ethis.decodeHtml(viv.alt.toLowerCase());
                    var tmpglr = ethis.modal.querySelector('[data-sel-alt="' + tmpSelAlt + '"]');
                    $(tmpglr).show();
                    //$(tmpglr).css('display',null);
                    var tmpsld = ethis.slider.querySelector('[data-sel-alt="' + tmpSelAlt + '"]');
                    //$(tmpsld).show();
                    $(tmpsld).css('display',"");
                    if(ethis.media){
                      var tmp = ethis.media.querySelector('[data-sel-alt="' + tmpSelAlt + '"]');
                      $(tmp).show();
                    }
                    if (toSel == null) {
                        toSel = tmp;
                    }
                 }else{
                   var tmpli = $("[media-id='"+viv.id+"']");
                    $(tmpli).css('display',"");
                 }
              });   
          }
          
            customizerOnSelectCallback(varaint, product);
        }
       
        if(typeof(allVarImg) == 'undefined' || !allVarImg) return;
        var clrObj = $(".colors_comp")[0];
        clrObj.updateColors(varaint, product);

        if (this.preserveApprovedAIPreview()) return;

        let variantSelect = this.closest('.product__info-container').querySelector('variant-selects');
        if(variantSelect){
          variantSelect.addEventListener('change', () => imageRefreshSelectCallback(varaint, product));
        }
        setTimeout(() => imageRefreshSelectCallback(varaint, product), 500);
        this.filterMedia(varaint);
        if(this.media && typeof this.media.resetPages == 'function') this.media.resetPages();
    }
   isNoCustom(){
       return "1" == $("#cst_nc").val();
    }
    filterMedia(v) {
      if (this.preserveApprovedAIPreview()) return;
      if(typeof no_variant_images != 'undefined' && no_variant_images == true){
        return;
      }
      if(typeof(allVarImg) == 'undefined' || !allVarImg) return;
        var clrObj = $(".colors_comp")[0];
        var clr = clrObj.getSelectedColor();
        $('[thumbnail-color]').hide().removeClass("loading-thumbnail");
        

        if (cst_previewHandler == null) {
            var selected_variant = "";//this.currentVariant.featured_media.alt;

            //var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';
            var selected_attribute = '[thumbnail-color="' + clr + '"]';

            if (selected_variant == selected_variant) {
                var tmpvarImg = allVarImg[v.id];
                var ethis = this;
                var toSel = null;
                $(tmpvarImg).each(function (ixi, viv) {
                    if (viv.length == 2 && (viv[0] == clr || viv[0] == 'any')) {
                        var tmpglr = ethis.modal.querySelector('[data-sel-alt="' + viv[1] + '"]');
                        $(tmpglr).show();
                        //$(tmpglr).css('display',null);
                        var tmpsld = ethis.slider.querySelector('[data-sel-alt="' + viv[1] + '"]');
                        //$(tmpsld).show();
                        $(tmpsld).css('display',"");
                        var targets = ethis.resolveMediaTargets(viv[1]);
                        var tmp = targets.thumbnail || targets.gallery;
                        $(targets.thumbnail).show();
                        $(targets.gallery).show();
                        if (toSel == null) {
                            toSel = targets;
                        }
                    }
                });
                if (toSel) {
                    this.activateMediaTarget(toSel);
                }

            }
        } else {
            // from cust
            if (selected_variant == selected_variant) {
                var tmpvarImg = allVarImg[v.id];
                var ethis = this;
                var toSel = null;
                var lstToShow = [];
                var crtselCstInfo = this.getSelectedVariantImages();
                $(tmpvarImg).each(function (ixi, viv) {
                    if (viv.length == 2 && (viv[0] == clr || viv[0] == 'any')) {

                        var tmpglr = ethis.modal.querySelector('[data-sel-alt="' + viv[1] + '"]');
                        $(tmpglr).show();
                      
                      var tmpsld = ethis.slider.querySelector('[data-sel-alt="' + viv[1] + '"]');
                        //$(tmpsld).show();
                        $(tmpsld).css('display',"");
                      
                        if(ethis.media){
                          var tmp = ethis.media.querySelector('[data-sel-alt="' + viv[1] + '"]');
                          //$(tmp).show();
                          if (toSel == null) {
                              toSel = tmp;
                          }
                        }

                        if (crtselCstInfo) {
                            var tcrtCst = crtselCstInfo.cst.Pictures.find(a => a.imgalt && a.imgalt.toLowerCase() == viv[1]);
                            if (tcrtCst) {
                                if (!ethis.isNoCustom() && lstToShow.length > 0 && tcrtCst.UseForCustomizer !== true) {
                                    $(tmpsld).hide();
                                    return;
                                }
                                lstToShow.push(tcrtCst);
                            }
                        }

                    }
                });
                $(lstToShow).each(function (ix1, viv) {
                    var alt1 = viv.imgalt.toLowerCase();
                    var targets = ethis.resolveMediaTargets(alt1);
                    var tmp = targets.thumbnail || targets.gallery;
                    if (!tmp || !targets.gallery) {
                        return;
                    }
                    if(!ethis.isNoCustom())
		{
                      $(targets.thumbnail).addClass("loading-thumbnail").show();
                      $(targets.gallery).addClass("loading-thumbnail").show();
                    }
                    //if(ix1 ==0)
                    {
                        if(!ethis.isNoCustom())
			{
                          ethis.loadCustomImage(viv);
                        }
                        if (ix1 == 0)
                            ethis.activateMediaTarget(targets);

                    }

                });
                //if(toSel){             $(toSel).show();}
            }
        }
      if(this.slider)
        this.slider.resetPages();
    }
    refreshImg(trg) {
      var t1 = this.normaliseMediaAlt((trg && (trg.imgalt || trg.alt)) || this.alt);
      var targets = this.resolveMediaTargets(t1);
      $(targets.thumbnail).removeClass("loading-thumbnail");
      $(targets.gallery).removeClass("loading-thumbnail");
    }
    loadCustomImage(viv) {
        if (this.preserveApprovedAIPreview()) return Promise.resolve(false);
        var alt1 = viv.imgalt.toLowerCase();
        var targets = this.resolveMediaTargets(alt1);
        if (!targets.thumbnail && !targets.gallery) return Promise.resolve(false);
        var modalTarget = this.findMediaByAlt(this.modal, alt1);

        return cst_previewHandler(viv.image).then(
            (r) => {
                if (this.preserveApprovedAIPreview()) return;
                if (!r || r === false) return;
                if (r.url) {
                    return ImgLoadAsync(r.url).then(() => {
                        if (this.preserveApprovedAIPreview()) return;
                        this.updateRenderedImage(targets.thumbnail, r.url);
                        this.updateRenderedImage(targets.gallery, r.url);
                        this.updateRenderedImage(modalTarget, r.url);
                        $(targets.thumbnail).removeClass("loading-thumbnail");
                        $(targets.gallery).removeClass("loading-thumbnail");
                    });

                }
            },
            (rj) => { console.log(rj); });
    }
    getSelectedVariantImages() {
        var cc = this.getcolorsComp();
        return cc.getSelectedCstInfo();

    }
    getcolorsComp() {
        return $(".colors_comp")[0];
    }
    findProduct() {
        return JSON.parse(this.closest('section').querySelector('#product-data').getAttribute('data-product'));
    }

    findSelectedVariant() {
        let idEle = this.closest('.product__info-container').querySelector('[id^="product-form-installment"] [name="id"]'); 
        if (!idEle) {
            return;
        }
        let varaintId = idEle.value;
        if (!varaintId) {
            return;
        }
        //let varaints = this.closest('.product__info-container').querySelector('variant-selects').getVariantData();
        let varaints = FindMainProductHelper.findProduct().variants;
        return varaints.find((i) => i.id == varaintId);
    }
}
window.customElements.define('dyefor-customizer', DyeforCustomizer);

class DyeforPersonaliseMessage extends HTMLElement {
    constructor() {
        super();
    }
    copyWriteNoticeAgreed = false;
    connectedCallback() {
        $('body').on("personaliseFormShow", () => {
            if (this.copyWriteNoticeAgreed != true) {
                this.show();
            }
        });

        for (const closebtn of this.querySelectorAll('.closebtn')) {
            closebtn.addEventListener('click', () => {
                this.hide(false);
            });
        }

        this.querySelector('.personalisemessage-accept').addEventListener('click', () => {
            this.hide(true);
            this.copyWriteNoticeAgreed = true;
        });
    }

    show() {
        this.querySelector("#personalisemessage-modal").style.display = 'block';
    };

    hide(accepted) {
        this.querySelector("#personalisemessage-modal").style.display = 'none';
        if (accepted !== true) {
            CancelCustomizer();
        }
        document.body.style.overflow = 'scroll';
    };

}
window.customElements.define('dyefor-personalise-message', DyeforPersonaliseMessage);


class DyeforLeatherSwatch extends HTMLElement{
    constructor() {
        super();
    }
    connectedCallback(){
        for(const li of this.querySelectorAll('ul.leather-swatch-ul li')){
            li.addEventListener('click', (event)=>{
                event.preventDefault();
                let ul = li.closest('ul');
                if(ul.getAttribute('data-calc_url')=='false'){
                    let url = '/products/' + li.getAttribute('data-url');
                    window.location.href = url;
                    return;
                }

                let urlTemplate = ul.getAttribute('data-calc_urltemplate');
                let source = urlTemplate.replace('(.*)', ul.getAttribute('data-selected_value'));
                let target = urlTemplate.replace('(.*)', li.getAttribute('data-value'));
                let url = productHandle.replace(source, target);
                window.location.href = '/products/' +url;
            })
        }
    }
}
window.customElements.define('dyefor-leather-swatch', DyeforLeatherSwatch);

class ProductMakeSelect {
    init() {
        if(productType && productType == 'Phone Case' || productType == "SamsungV2" || productType == "AppleV2" || productType == "Phone Case Breed" || productType == "Samsung Vegan Leather Flip Phone Case"){
            setTimeout(()=>{
              try
              {
                this.generateRelatedLinks();
                this.generateRelatedLinks2();
                this.addMakeSelect();
              }
              catch(error){console.log(error);} 
            }, 300);
          }
    }
    phoneMakes2=[
        {
          "name":"Apple",
          "value": "iphone"
        },
        {
          "name":"Google",
          "value": "google"
        },
        {
          "name":"Nokia",
          "value": "nokia"
        }, 
        {
          "name":"Samsung",
          "value": "samsung"
        },
        {
          "name":"Sony",
          "value": "sony"
        },
        {
          "name":"OnePlus",
          "value": "oneplus"
        },
        {
          "name":"Huawei",
          "value": "huawei"
        }];
    phoneMakes=[
        {
          "name":"Apple",
          "value": "iphone"
        },
        {
          "name":"Apple",
          "value": "apple-iphone"
        },
        {
          "name":"Apple",
          "value": "protective-iphone"
        },
        {
          "name":"Google",
          "value": "google"
        },
        {
          "name":"Nokia",
          "value": "nokia"
        }, 
        {
          "name":"Samsung",
          "value": "samsung"
        },
        {
          "name":"Samsung",
          "value": "samsung-galaxy"
        },
        {
          "name":"Samsung",
          "value": "protective-samsung-galaxy"
        },
        {
          "name":"Sony",
          "value": "sony"
        },
        {
          "name":"Sony",
          "value": "sony-xperia"
        },
        {
          "name":"OnePlus",
          "value": "oneplus"
        },
        {
          "name":"Huawei",
          "value": "huawei"
        }
        ];
    relatedLinks = [];
    relatedLinks2 = [];
    generateRelatedLinks(){
        if(!patternListMeta) return;

        patternListMeta.split(',').forEach(element=>{
            let item = element.trim();
            if(!item.startsWith("/products/")){
                item = "/products/" + item;
            }
            if(this.relatedLinks.indexOf(item) === -1){
                this.relatedLinks.push(item);
            }
        });

    }
    generateRelatedLinks2(){
        if(!relatedProductLinkMeta) return;
        relatedProductLinkMeta.split(',').forEach(item => {
            item = item.trim();
            if(!item.startsWith("/products/")){
            item = "/products/" + item;
            }
            if(this.relatedLinks2.indexOf(item) === -1){
            this.relatedLinks2.push(item);
            }
        });
    }
    findCurrentMake() {
        let crrentUrl = window.location.href.split("?")[0];
        let currentMake;
        let template = "";
        this.phoneMakes.forEach(function (item) {
            if (crrentUrl.includes(item.value)) {
                currentMake = item;
                template = crrentUrl.replace(item.value, "XXXXXXXXXX");
            }
        });
        if (currentMake != null) {
            currentMake["urlTemplate"] = template;
        }
        return currentMake;
    }
    addMakeSelect() {
        let currentMake = this.findCurrentMake();
        if (currentMake === undefined) {
            return;
        }
        let toAddSelectItems = [];
        if (this.relatedLinks2.length > 0) {
            this.phoneMakes2.forEach(item => {
                if (currentMake.value.indexOf(item.value) == -1) {
                    this.relatedLinks2.forEach(handle => {
                        if (handle.indexOf(item.value) != -1) {
                            toAddSelectItems.push({ name: item.name, value: item.value, url: handle, selected: false });
                        }
                    });
                } else {
                    toAddSelectItems.push({ name: item.name, value: item.value, url: window.location.href.split("?")[0], selected: true });
                }
            });
        }

        this.phoneMakes.forEach(item => {
            if (!toAddSelectItems.some(i => i.name === item.name)) {
                if (currentMake.name !== item.name) {
                    var newUrl = currentMake.urlTemplate.replace('XXXXXXXXXX', item.value).replace('https://www.dyefor.com', '').replace('http://127.0.0.1:9292', '');
                    if (this.relatedLinks.includes(newUrl)) {
                        toAddSelectItems.push({ name: item.name, value: item.value, url: newUrl, selected: false });
                    }
                } else {
                    toAddSelectItems.push({ name: item.name, value: item.value, url: window.location.href.split("?")[0], selected: true });
                }
            }
        });
        if (toAddSelectItems.length > 0) {
           let makeSelect = document.querySelector('.make-select')
           toAddSelectItems.forEach((item)=>{
               let newOption = document.createElement('option');
               newOption.text = item.name;
               newOption.value = item.url;
               newOption.selected = item.selected;
               makeSelect.add(newOption);
           });

           makeSelect.addEventListener('change', (event)=>{
               //event.stopImmediatePropagation();
               //event.preventDefault();
               window.location.href = event.currentTarget.value;
           });
        }
    }
}


let productMkSelect = new ProductMakeSelect();
productMkSelect.init();

class DyeforSwatchButtonSelect extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        let cstBtnSelector = this.querySelector('.cstBtnSelector');
        if(!cstBtnSelector){
            return;
        }

        let optionId = cstBtnSelector.getAttribute('target-select');
        for(const btn of this.querySelectorAll('.cstBtnSelector .case_btn_ext')){
            btn.addEventListener('click', (event)=>{
              let select = document.querySelector('#' + optionId);
              select.value = btn.getAttribute('data-clr');
              this.closest('variant-selects').dispatchEvent(new Event('change'));
            });
          }

    }
}
window.customElements.define('dyefor-swatch-button-select', DyeforSwatchButtonSelect);

class DyeforSwatchImageSelect extends HTMLElement{
    constructor(){
        super();
    }
    dropdown = null;
    variantSelect = null;
    wrapDiv = null;
    imagepath="";
    moneyFormat
    connectedCallback(){
        setTimeout(() => {
            this.init();            
        });        
    }
    init(){
        this.moneyFormat = this.getAttribute('data-money-format')||"";
        if(productType == 'Balloons' || productType == 'Balloon'){
            this.dropdown = this.querySelector('select[name="options[Balloon Package]"]');
        }else{

            this.dropdown = this.querySelector('select[name="options[Case Type]"]');
        }
        this.variantSelect = this.closest('.product__info-container').querySelector('variant-selects');
        this.imagepath = this.getAttribute('image-url');
        if(this.dropdown){
            const observer = new MutationObserver(mutations => {      
                this.updateUi();
            });
            observer.observe(this.dropdown, {
                subtree: false,
                attributes: false,
                childList: true,
            });
        }

        this.updateUi();
    }

    updateUi(){
        let select1 =  document.querySelector('variant-selects select[data-option="option1"]');
        let productName = "";
        if(select1){
            productName = select1.value;
        }
        // let cm = this.querySelector('.christmass-message-wrap-iphone-15-pro-max');
        //     if(cm){
        //         if(productName == 'iPhone 15 Pro Max'){
        //             cm.classList.remove('hidden');
        //         }else{
        //             cm.classList.add('hidden');
        //         }
        //     }     
        this.wrapDiv = this.querySelector('.cstImageBtnSelector');
        if(!this.wrapDiv){
            this.classList.add('hidden');
            return;
        }
        this.wrapDiv.innerHTML = "";
        
        if(this.dropdown ){    
            let options = this.dropdown.querySelectorAll('option');
            options.forEach((option)=>{
                var listItem = document.createElement('div'); 
                listItem.classList.add('case_btn_ext');
                listItem.innerHTML = option.value;
                let nextItemClassName = "";
                if(option.value == this.dropdown.value){
                    nextItemClassName = 'cst-btn-selected';
                    this.querySelector('.selected-case-name').innerHTML = option.value;
                }
                listItem.setAttribute('data-clr', option.value);
                listItem.setAttribute('title', option.value);
                let mainImage = this.imagepath;
                let setOpacity = "opacity: 0;";
                if(option.hasAttribute('data-product-image')){
                    mainImage = option.getAttribute('data-product-image');
                    setOpacity = "";
                }
                listItem.innerHTML = `<div class="case_btn_ext ${nextItemClassName}" data-clr="${option.value}" title="${option.value}" productName="${productName}">
                <div class="case_btn">
                  <img class="case-edge-image" src="${mainImage}" style="${setOpacity}" />
                  <span class="price-line">${option.value}</span>
                </div>
              </div>`;
                this.wrapDiv.appendChild(listItem);
                listItem.addEventListener('click', ()=>{
                    this.dropdown.value = option.value;
                    this.querySelectorAll('.cst-btn-selected').forEach((i)=>i.classList.remove('cst-btn-selected'));
                    listItem.classList.add('cst-btn-selected');
                    this.variantSelect.dispatchEvent(new Event('change'));
                    this.querySelector('.selected-case-name').innerHTML = option.value;
                })
            });
            try{
            this.updatePrice();
            }
            catch{}
        }
    }

    updatePrice(){
        if(!meta || !meta.product){
            return;
        }
        let variants = meta.product.variants;
        let phoneSelect  = document.querySelector('select[name="options[Phone Case]"]');
        if(productType == 'Balloons' || productType == 'Balloon'){
            phoneSelect = document.querySelector('select[name="options[Balloon Package]"]');
        }
        let currentVariants = variants.filter(p=> p.public_title.startsWith(phoneSelect.value + " /"));
        if(productType == 'Balloons' || productType == 'Balloon'){
            currentVariants = variants;
        }
        let variantSelect = this.closest('variant-selects');
        let productData = null;
        if(variantSelect){
            productData = variantSelect.getProductData();
        }
        let variantPrice = currentVariants.map(p=> ({id:p.id, price: p.price, name: p.public_title.replace(phoneSelect.value + " /", "").trim()}));
        variantPrice.forEach(element => {
            let priceLine = this.querySelector(`.case_btn_ext[data-clr="${element.name}"] .price-line`);
            let available = true;
            if(productData){
                let thisVaraint = productData.variants.filter(p=> p.id == element.id);
                if(thisVaraint.length){
                    available = thisVaraint[0].available;
                    if(!available){
                        let wrap = this.querySelector(`.case_btn_ext[data-clr="${element.name}"]`);
                        if(wrap){
                            wrap.classList.add('disabled');
                        }
                    }
                }
            }
            if(priceLine){
                priceLine.innerHTML = Shopify.formatMoney(element.price, this.moneyFormat);
            }
        });
    }
}


window.customElements.define('dyefor-swatch-image-select', DyeforSwatchImageSelect);


class DyeforProductDelayMessage extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        setTimeout(() => {
            this.init();            
        });        
    }
    init(){
        let variantSelect = document.querySelector('.product__info-container variant-selects');
        if(variantSelect){
          variantSelect.addEventListener('change', () => this.refreshMessage());
        }
        this.refreshMessage();
    }
    refreshMessage(){
        let select1 =  document.querySelector('variant-selects select[data-option="option1"]');
        let productName = "";
        if(select1){
            productName = select1.value;
        }else{
            return;
        }
        let showMessageFotItems = [''];
        let cm = this.querySelector('.christmass-message-wrap-iphone-15-pro-max');
        if(showMessageFotItems.includes(productName.toLowerCase())){
            cm.querySelector('.christmass-message-message').innerHTML = `New orders for ${productName} will no longer arrive in time for Christmas.`;
            cm.classList.remove('hidden');
        }else{
            cm.classList.add('hidden');
        }
    }
}

window.customElements.define('dyefor-product-delay-message', DyeforProductDelayMessage);

class ImageWarningTooltip extends HTMLElement{
    constructor(){
        super()
    }

    connectedCallback(){
        setTimeout(() => {
         this.init();
        });
    }

    init(){
        this.classList.remove('hidden');
        let btn  = this.querySelector('.image_warning_close button');
        if(btn){
            btn.addEventListener('click', (event)=>{
                event.stopImmediatePropagation();
                this.classList.add('hidden');
            });
        }
        setTimeout(() => {
            this.classList.add('hidden');
        }, 1000*1*60);
    }
}
window.customElements.define('image-warning-tooltip', ImageWarningTooltip);
class Iphone16WarningTooltip extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        setTimeout(() => {
            this.init();
        });
    }

    init() {
        //todo manu
        let btn = this.querySelector('.image_warning_close button');
        if (btn) {
            btn.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                this.classList.add('hidden');
            });
        }
        let variantSelect = this.closest('.product').querySelector('variant-selects');
        if (variantSelect) {
            variantSelect.addEventListener('change', () => this.refreshMessage());
        }
        this.refreshMessage();
    }
    refreshMessage() {
        const variant = this.findSelectedVariant();
        console.log(variant);
        if (variant && (variant.option1 == 'iPhone 16' || variant.option1 == 'iPhone 16 Plus')) {
            this.classList.remove('hidden');
        } else {
            this.classList.add('hidden');
        }
    }

    findSelectedVariant() {
        let idEle = this.closest('.product').querySelector('[id^="product-form-installment"] [name="id"]');
        if (!idEle) {
            return;
        }
        let varaintId = idEle.value;
        if (!varaintId) {
            return;
        }
        
        let varaints = FindMainProductHelper.findProduct().variants;
        return varaints.find((i) => i.id == varaintId);
    }
}
window.customElements.define('iphone16-warning-tooltip', Iphone16WarningTooltip)
class NotInStockItemMessage{
    init(){
        setTimeout(()=>{
            try{
                let variantSelects = document.querySelector('variant-selects');

                if(variantSelects){
                    variantSelects.addEventListener('change', this.updateNotInStockMessage)
                }
                this.updateNotInStockMessage();
            }
            catch{

            }
        }, 500);
    }
    updateNotInStockMessage(){
        try{
            let notInStockTitles = ['S22', 'iPad 7 (10.2 inch 2019)', 'iPad 8 (10.2 inch 2020)', 'iPad 9 (10.2 inch 2021)'];
            let idEle = document.querySelector('.product__info-container').querySelector('[id^="product-form-installment"] [name="id"]'); 
            if (!idEle) {
                return;
            }
            let varaintId = idEle.value;
            if (!varaintId) {
                return;
            }
            //let varaints = this.closest('.product__info-container').querySelector('variant-selects').getVariantData();
            let varaints = FindMainProductHelper.findProduct().variants;
            let varaint = varaints.find((i) => i.id == varaintId);
            if(notInStockTitles.some((i)=> i == varaint.title)){
                //hide christmas message;
                document.querySelectorAll('.christmass-message-wrap').forEach((x)=> x.classList.add('hidden'));
                document.querySelectorAll('.deliverycountdown').forEach((x)=> x.classList.add('hidden'));
                //show not in stock message;
                document.querySelectorAll('.notInStock-message-wrap').forEach((x)=> x.classList.remove('hidden'));
                document.querySelectorAll('.notInStock-message-message').forEach((x)=> x.innerHTML = `${varaint.title} has a production time of 14 days`)
            }else{
                //show christmas message;
                document.querySelectorAll('.christmass-message-wrap').forEach((x)=> x.classList.remove('hidden'));
                document.querySelectorAll('.deliverycountdown').forEach((x)=> x.classList.remove('hidden'));
                //hide not in stock message;
                document.querySelectorAll('.notInStock-message-wrap').forEach((x)=> x.classList.add('hidden'));
            } 
        }catch(error){
            console.log(error);
        }
    }
}
let notInStockMessage = new NotInStockItemMessage();
notInStockMessage.init();
